export const en: Record<string, string> = {
  "profile.setupExplanation": "Blank optional fields do not reduce this score. Jobseeker requirements are checked separately.",
  "reviews.review": "review",
  "reviews.reviews": "reviews",
  "reviews.outOfFive": "out of 5",
  "reviews.on": "on",
  "reviews.role.seller": "as a seller",
  "reviews.role.buyer": "as a buyer",
  "reviews.role.provider": "as a provider",
  "reviews.role.client": "as a client",
  "profile.ratingsFeedback": "Ratings & Feedback",
  "profile.basedOnReviews": "Based on {count} reviews",
  "profile.trustIndicators": "Trust indicators",
  "profile.verifiedIdentity": "Verified Identity",
  "profile.verifiedCompany": "Verified Company",
  "profile.approvedCredentials": "Approved credentials",
  "profile.about": "About",
  "profile.portfolio": "Portfolio",
  "profile.services": "Services",
  "profile.jobs": "Jobs",
  "profile.projectBidding": "Project Bidding",
  "profile.requestQuotes": "Request for Quotes",
  "profile.marketplace": "Marketplace",
  "profile.clientReviews": "Client reviews",
  "profile.portfolioWorks": "Portfolio works",
  "profile.backToAccount": "Back to account",
  "profile.jobseekers": "Jobseekers",
  "profile.hire": "Hire",
  "profile.downloadResume": "Download résumé",
  "profile.aboutPerson": "About {name}",
  "profile.education": "Education",
  "profile.verificationCertifications": "Verification & certifications",
  "profile.otherPosts": "Other posts by {name}",
  "profile.posts": "posts",
  "profile.viewMore": "View more",
  "profile.viewDetails": "View details",
  "profile.edit": "Edit profile",
  "profile.skills": "Skills",
  "profile.experience": "Experience",
  "profile.availability": "Availability",
  "profile.status.available": "Available",
  "profile.status.busy": "Busy",
  "profile.status.unavailable": "Not available",
  "profile.identityVerified": "Verified Identity",
  "profile.professionalVerified": "Verified Professional",
  "profile.identityProfessionalVerified": "Verified Identity & Professional",
  "profile.addResume": "Add résumé",
  "profile.updateResume": "Update résumé",
};

export const tl: Record<string, string> = {
  "profile.setupExplanation": "Hindi bumababa ang porsiyento kapag blangko ang opsyonal na impormasyon. Hiwalay na sinusuri ang mga kailangan sa Jobseekers.",
  "reviews.review": "review",
  "reviews.reviews": "mga review",
  "reviews.outOfFive": "sa 5",
  "reviews.on": "sa",
  "reviews.role.seller": "bilang nagbebenta",
  "reviews.role.buyer": "bilang mamimili",
  "reviews.role.provider": "bilang provider",
  "reviews.role.client": "bilang kliyente",
  "profile.ratingsFeedback": "Mga Rating at Feedback",
  "profile.basedOnReviews": "Batay sa {count} review",
  "profile.trustIndicators": "Mga palatandaan ng tiwala",
  "profile.verifiedIdentity": "Beripikado ang pagkakakilanlan",
  "profile.verifiedCompany": "Beripikadong kumpanya",
  "profile.approvedCredentials": "Aprubadong kredensyal",
  "profile.about": "Tungkol sa",
  "profile.portfolio": "Portfolio",
  "profile.services": "Mga Serbisyo",
  "profile.jobs": "Mga Trabaho",
  "profile.projectBidding": "Pagbi-bid ng Proyekto",
  "profile.requestQuotes": "Mga Kahilingan ng Sipi",
  "profile.marketplace": "Marketplace",
  "profile.clientReviews": "Mga review ng kliyente",
  "profile.portfolioWorks": "Mga gawa sa portfolio",
  "profile.backToAccount": "Bumalik sa account",
  "profile.jobseekers": "Mga Naghahanap ng Trabaho",
  "profile.hire": "I-hire",
  "profile.downloadResume": "I-download ang résumé",
  "profile.aboutPerson": "Tungkol kay {name}",
  "profile.education": "Edukasyon",
  "profile.verificationCertifications": "Pagpapatunay at mga sertipikasyon",
  "profile.otherPosts": "Iba pang post ni {name}",
  "profile.posts": "mga post",
  "profile.viewMore": "Tingnan pa",
  "profile.viewDetails": "Tingnan ang mga detalye",
  "profile.edit": "I-edit ang Profile",
  "profile.skills": "Mga Kasanayan",
  "profile.experience": "Karanasan",
  "profile.availability": "Pagiging Available",
  "profile.status.available": "Available",
  "profile.status.busy": "Abala",
  "profile.status.unavailable": "Hindi Available",
  "profile.identityVerified": "Kumpirmado ang Pagkakakilanlan",
  "profile.professionalVerified": "Kumpirmadong Propesyonal",
  "profile.identityProfessionalVerified": "Kumpirmadong Pagkakakilanlan at Propesyonal",
  "profile.addResume": "Magdagdag ng résumé",
  "profile.updateResume": "I-update ang résumé",
};
